import { CredentialRoles } from '@amzn/event-engine-js-utils';
import { GetContentBuildRequest } from '@amzn/event-engine-sdk/clients/eventenginecontentcatalogservice';
import EventEngineClientFactory from 'contexts/EventEngineClientFactory';

const contentCatalogClient = EventEngineClientFactory.getClientSingleton(
    'EEContentCatalogClient'
);

const getEEContentCatalogClient = async (role: CredentialRoles = 'Portal') =>
    await contentCatalogClient.getClient(role);

async function getContentBuild(params: GetContentBuildRequest) {
    const eeContentCatalogClient = await getEEContentCatalogClient();
    return await eeContentCatalogClient.getContentBuild(params).promise();
}

export default {
    getContentBuild,
};
